import React from 'react'
import * as C from "../componentsM/index";

const CASProgram = () => {
    return (
        <>

            <C.Hero title={"CAS PROGRAMME"} image={"/hero/19.jpg"} />

            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>




                <h1 className="font-semibold">
                CAS (Creativity, Activity Service) enables students to demonstrate attributes of the IB learner profile in real and practical ways, to grow as unique individuals. CAS complements a challenging academic programme in a holistic way, providing opportunities for self-determination, collaboration, accomplishment and enjoyment . The range of different activities should be equally balanced between the three key components of the programme.
                </h1>




                




                <h1 className="font-semibold">
                Creativity – is interpreted as imaginatively as possible to cover a wide range of arts and other activities outside the normal curriculum which include creative thinking in the design and carrying out of service projects.
                </h1>



                




                <h1 className="font-semibold">
                Activity – can include participation in expeditions, individual and team sports and physical training; it can also include carrying out creative and service projects.
                </h1>




                




                <h1 className="font-semibold">
                Service – involves interaction, such as the building of links with individuals or groups in the community. The community may be the school, the local district, or it may exist on national and international levels (such as undertaking projects of assistance in a developing country). Service activities should not only involve doing things for others, but also doing things with others and developing a real commitment with them. The relationship should therefore show respect for the dignity and self-respect of others.
                </h1>




                <h1 className="font-semibold">
                An activity in which C reativity, A ctivity and S ervice are separate, is as valid as one in which all three are integrated into a single project.
                </h1>



                <h1 className="font-semibold">
                A CAS Activity can either be offered by the school or initiated by a student or group of students, subject to approval by the school.
                </h1>






                <h1 className="font-semibold">
                Students are required to fulfill following learning outcomes throughout their CAS programme:
                </h1>






                <h1 className="font-semibold">
                LO1
                </h1>





                <h1 className="font-semibold">
                Identify own strengths and develop areas for growth
                </h1>




                <h1 className="font-semibold">
                LO2
                </h1>


                <h1 className="font-semibold">
                Demonstrate that challenges have been undertaken, developing new skills
                </h1>



                <h1 className="font-semibold">
                LO3
                </h1>


                <h1 className="font-semibold">
                Demonstrate how to initiate and plan a CAS experience
                </h1>



                <h1 className="font-semibold">
                LO4
                </h1>


                <h1 className="font-semibold">
                Show commitment to and perseverance in CAS experiences
                </h1>



                <h1 className="font-semibold">
                LO5
                </h1>


                <h1 className="font-semibold">
                Demonstrate the skills and recognise the benefits of working collaboratively
                </h1>




                <h1 className="font-semibold">
                LO6
                </h1>


                <h1 className="font-semibold">
                Demonstrate engagement with issues of global significance
                </h1>





                <h1 className="font-semibold">
                LO7
                </h1>


                <h1 className="font-semibold">
                Recognise and consider the ethics of choices and actions
                </h1>



                <h1 className="font-semibold">
                Recognise and consider the ethics of choices and actions
                </h1>



                <h1 className="font-semibold">
                CAS Portfolios are compiled by students as evidence of their progress and completion of the CAS programme. Students use the CAS stages (investigation, preparation, action, demonstration and reflection) as a framework for CAS experiences and the CAS project. CAS emphasises reflection which is central to building a deep and rich experience in CAS.
                </h1>

                <h1 className="font-semibold">
                Student completion of CAS is based on the achievement of the seven CAS learning outcomes realised through the student’s commitment to his or her CAS programme over a period of 18 months.
                </h1>







                </div>


            </section>

        </>
    )
}

export default CASProgram